import { useCallback, useState } from 'react';

const DEFAULT_CAP = 5;

/**
 * For long filter lists: toggles visibility of options after index cap-1.
 * Use with per-option `style={{ display: isHidden(i) ? 'none' : undefined }}` on direct Checkbox children of Checkbox.Group.
 */
export function useCollapsibleFilterSection(
  itemCount: number,
  cap = DEFAULT_CAP,
) {
  const [expanded, setExpanded] = useState(false);
  const showToggle = itemCount > cap;
  const isHidden = useCallback(
    (index: number) => showToggle && !expanded && index >= cap,
    [showToggle, expanded, cap],
  );
  return { expanded, setExpanded, showToggle, isHidden };
}
